// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__t8dow","info":"PatientInfo_info__2ZixK"};